<template>
  <div :class="{ '  pa-4 ma-1 ': md, 'pa-4 ma-1': !md }" class="pa-lg-10 card pr-lg-16 ">
    <div class="topcont d-flex d-inline-block">
      <h2
        :class="{ titlemd: md }"
        class="toptext  font-weight-bold text-truncate title text-sm-h5  text-lg-h2 text-md-h3 text-h5"
      >
        {{ title }}
      </h2>
      <img :class="{ smilymd: md }" class="smily mr-md-10 mr-3" :src="emoji" />
      <img />
    </div>
    <div class="disc">
      <h5
        :class="{ textmd: md }"
        class="text-left text-lg-h4 text-md-h5 text-subtitle-2 pr-14"
      >
        {{ descTop }}
      </h5>
      <h5 class=" desc text-lg-h3  text-sm-subtitle-2  text-md-h5 text-left text-subtitle-2 pr-8">
        {{ descBot }}
      </h5>
    </div>

    <div class="down mb-3">
      <h1 class="value font-weight-bold text-sm-h3 text-lg-h1 text-md-h3 text-h4 text-left">
        {{ value }}
      </h1>
      <h5 class=" text-subtitle-2 text-md-h3 right-bot-text  text-left">{{ unit }}</h5>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardRight",
  props: {
    emoji: String,
    title: String,
    descTop: String,
    descBot: String,
    value: Number,
    unit: String,
  },
  data() {
    return { md: false };
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  unmounted() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.md = window.matchMedia("(max-aspect-ratio:1/1)").matches
        ? true
        : false;
      console.log(this.leftcard);
    },
  },
};
</script>

<style>
.textmd {
  font-size: 0.5em;
}
.cardright {
  border-radius: 2em;
  background-color: #1a3838;
}
.right-bot-text {
  font-size: 2.5vh;
  font-weight: 200;
}
.smaller-number {
  font-size: 10vh;
  font-weight: bold;
}
.smily {
  position: absolute;
  right: 0;
  height: 9vh;
}
.smilymd {
  position: absolute;
  right: 0;
  top: 3vh;
  height: 5vh;
}
.title {
  font-size: 1.5em;
}
.titlemd {
  font-size: 0.5em;
}
.value {
  font-size: calc(((4.2vh + 4.2vw) / 2 ) + 0.2em)  !important ;
}
.h1 {
  font-size: calc(((5vh + 5vw) / 2 ) + 0.2em)  !important ;
}
.desc {
  font-size: calc(((2.5vh + 2.5vw) / 2 ) )  !important ;
}
.toptext{
  font-size: calc(((3.5vh + 3.5vw) / 2 ) )  !important ;
}
</style>
